import React, { useState, useEffect } from "react";
import { Modal, Box, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { current } from "immer";
import config from "../../../config/aws-exports";
import { makeStyles } from "@material-ui/core/styles";
import {
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Typography,
  LinearProgress,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector } from "react-redux";
import { authData } from "../../../redux/auth/authSlice";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import DialogContent from "@mui/material/DialogContent";
import Downloadcsv from "./Downloadcsv";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    width: "100%",
    paddingTop: "20px",
  },
  root1: {
    width: "100%",
  },
  programtitle: {
    fontSize: "18px",
    color: config.main_color_1,
  },
  heading: {
    fontSize: "18px",
    fontWeight: 400,
    color: config.main_color_1,
  },
  coursetitle: {
    fontSize: "16px",
    fontWeight: 400,
    color: config.main_color_2,
  },
  paper: {
    "& .MuiDialog-paperWidthSm": {
      minWidth: "1100px",
    },
  },
  modulename: {
    fontSize: "14px",
    fontWeight: 400,
    color: "black",
    width: "60%",
  },
  subheading: {
    color: "black",
    fontFamily: "nunito",
    fontSize: "14px",
    fontWeight: "600px",
  },
  "MuiAccordionDetails-root": {
    display: "inline-block",
    width: "100%",
    padding: "10px 20px",
  },
}));
export default function UserProgressPopUp(props) {
  // const {userPopOpen ,courseData} = props;
  const classes = useStyles();
  let userDetails = useSelector(authData);
  let arrHeader = ["otitle", "timespent"];
  let newHeaders = ["title", "timespent in %"];
  const handleClose = () => {
    props.setUserPopOpen(false);
  };
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress
            variant="determinate"
            color="primary"
            style={{ backgroundColor: "whitesmoke" }}
            {...props}
          />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      {props.userPopOpen && (
        <Dialog
          fullScreen={fullScreen}
          open={props.userPopOpen}
          onClose={handleClose}
          className={classes.paper}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
          <div style={{display:"flex",justifyContent:"end",margin:"-5px -20px 10px 0px"}}>
            <button
              onClick={handleClose}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              <CloseIcon fontSize="large" />
            </button>
            </div>
            <div style={{display:'flex'}}>
             <h3 style={{width:"100%",paddingBottom:'10px'}}>Course completion progress - {props.uname}</h3>
                <Downloadcsv maindata={props.courseData.unit} arrHeader={arrHeader} 
          newHeaders={newHeaders} filename={"Users"} />  
             </div>
            {props.courseData !== undefined &&
              props.courseData !== null &&
              props.courseData.unit.map((value) => (
                <div className="accholder">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={classes.programtitle}>
                        {value.unitname}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      {value.nuggets.map((nug) => (
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes.coursetitle}>
                              {nug.ntitle}
                            </Typography>
                          </AccordionSummary>
                          {nug.objects.map((obj) => {
                            let newvalue = parseInt(obj.oduration);
                            let percent = (Math.round(obj.userOP.timespent)/newvalue) * 100;
                            return (
                              <AccordionDetails>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    gap: "1rem",
                                  }}
                                >
                                  <h4 style={{ width: "40% " }}>
                                    {obj.otitle}
                                  </h4>
                                  <div style={{ width: "60%" }}>
                                    {obj.userOP.timespent === 0 ? (
                                      <LinearProgressWithLabel value={0} />
                                    ) : newvalue < obj.userOP.timespent ? (
                                      <LinearProgressWithLabel value={100} />
                                    ) : (
                                      <LinearProgressWithLabel
                                        value={percent > 100 ? 100 : percent}
                                      />
                                    )}
                                  </div>
                                </div>
                              </AccordionDetails>
                            );
                          })}
                        </Accordion>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
